import { Module } from 'vuex'

import { RootState } from '@/store/types'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { CarereceiverState } from './types'

const carereceiverModule: Module<CarereceiverState, RootState> = {
  namespaced: true,
  actions,
  mutations,
  getters,
  state: {
    // @TODO: delete careReceiverIdForCurrentBookingFunnel after a SR is created
    careReceiverIdForCurrentBookingFunnel: null,
    carereceiverProfilePageData: {
      needHelp: '',
      gender: '',
      firstName: '',
      lastName: '',
      age: '',
      street: '',
      houseNumber: '',
      postcode: '',
      city: '',
      additionalAddressInformation: '',
      careDegree: '',
      careReceiverDescription: '',
    },
  },
}

export default carereceiverModule
